import { useInRouterContext, useNavigate } from "react-router-dom";

/**
 * `navigate` del router cuando la pantalla vive dentro de uno; fuera de él
 * (pruebas que montan la sección suelta) cae a `window.location.assign`. El
 * contexto del router no cambia durante la vida del componente, así que la
 * llamada condicional al hook es estable.
 */
export function useSafeNavigate(): (to: string) => void {
  const inRouter = useInRouterContext();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const navigate = inRouter ? useNavigate() : null;
  return (to: string) => {
    if (navigate) navigate(to);
    else window.location.assign(to);
  };
}
